<template>
    <v-app>
        <v-main class="main">

            <!-- Sidebar -->
            <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
                @update:drawerOpen="drawerOpen = $event" />

            <v-container fluid class="main-content pa-4">

                <!-- Header -->
                <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

                <div class="content">

                    <!-- FILTER ROW -->


                    <v-row class="g-4 mt-4 mb-8" dense>

                        <!-- Details -->
                        <v-col cols="12" md="12" class="ps-md-3">
                            <div class="column-title mb-6">
                                <h5 class="m-0 text-left">Referral</h5>
                                <hr class="title-separator" />
                            </div>

                            <GlobalKyc />
                            <v-card class="outer-card chart-wrapper" style="border-radius: 8px;" flat>
                                <v-row>
                                    <v-col cols="12" class="d-flex justify-start mb-4">
                                        <v-btn variant="text" prepend-icon="mdi-chevron-left" @click="$router.back()">
                                            Back
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <hr class="title-separator" />
                                <v-card class="pa-3 inner-transaction-card" flat>

                                    <v-card class="outer-card" flat>
                                        <v-row dense class="g-2" style="height: 100%; padding: 16px;">

                                            <!-- FULL WIDTH COLUMN -->
                                            <v-col cols="12">

                                                <!-- INNER ROW (THIS FIXES YOUR ISSUE) -->
                                                <v-row dense>

                                                    <!-- LEFT COLUMN -->
                                                    <v-col cols="12" md="6" class="">

                                                        <!-- TOP CARD -->
                                                        <v-card class="flex-grow-1" flat>
                                                            <div class="pa-1">

                                                                <Panel toggleable v-model:collapsed="kinCollapsed">
                                                                    <template #header>
                                                                        <div class="flex items-center gap-2">
                                                                            <Button icon="pi pi-receipt"
                                                                                severity="secondary" rounded text
                                                                                style="color: green; font-size: 1.5rem;" />
                                                                            <span class="font-bold">How it works</span>
                                                                        </div>
                                                                    </template>

                                                                    <template #icons>
                                                                        <Menu ref="menu" id="config_menu" :model="items"
                                                                            popup />
                                                                    </template>
                                                                    <p class="m-0 text-left">
                                                                        How it works content goes here. This section
                                                                        explains how the investment product works,
                                                                        including details about
                                                                        interest rates, maturity, and any other relevant
                                                                        information that potential investors should know
                                                                        before investing.

                                                                    </p>
                                                                </Panel>
                                                            </div>
                                                        </v-card>

                                                        <!-- BOTTOM CARD -->
                                                        <v-card class="flex-grow-1" flat>
                                                            <div class="pa-1 justify-space-between">
                                                                <Panel toggleable v-model:collapsed="termCollapsed">
                                                                    <template #header>
                                                                        <div class="flex items-center gap-2">
                                                                            <Button icon="pi pi-receipt"
                                                                                severity="secondary" rounded text
                                                                                style="color: green; font-size: 1.5rem;" />
                                                                            <span class="font-bold">Terms</span>
                                                                        </div>
                                                                    </template>

                                                                    <template #icons>
                                                                        <Menu ref="menu" id="config_menu" :model="items"
                                                                            popup />
                                                                    </template>
                                                                    <p class="m-0 text-left">
                                                                        Terms content goes here. This section outlines
                                                                        the terms and conditions of the investment
                                                                        product,
                                                                        including any fees, penalties for early
                                                                        withdrawal, and other important legal
                                                                        information that investors
                                                                        need to be aware of before committing their
                                                                        funds.

                                                                    </p>
                                                                </Panel>
                                                            </div>
                                                        </v-card>

                                                    </v-col>

                                                    <!-- RIGHT COLUMN -->
                                                    <v-col cols="12" md="6" class="d-flex">

                                                        <v-card class="inner-card flex-grow-1 pa-3" flat>
                                                            <!-- ITEM 1 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Referrer Signups
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ totalReferred }}
                                                                </span>
                                                            </div>

                                                            <v-divider />

                                                            <!-- ITEM 2 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Total Bonus Earned
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ totalEarnedBonus }}
                                                                </span>
                                                            </div>

                                                            <v-divider />

                                                            <!-- ITEM 2 -->
                                                            <div
                                                                class="d-flex justify-space-between align-center py-3 mb-4">
                                                                <span class="text-body-2 font-weight-medium">
                                                                    Total Bonus Paid
                                                                </span>

                                                                <span class="text-body-2 font-weight-semibold">
                                                                    {{ totalPaid }}
                                                                </span>
                                                            </div>


                                                            <v-card class="inner-mini-card pa-4 mb-6" flat>
                                                                <v-row>
                                                                    <v-col cols="12" md="12">
                                                                        <div class="field">

                                                                            <!-- Main Label -->
                                                                            <label
                                                                                class="text-sm font-medium text-gray-700 d-block text-center mb-2">
                                                                                Referral Code
                                                                            </label>

                                                                            <div class="d-flex justify-center py-2 mb-2"
                                                                                style="background-color: #ffffff;">
                                                                                <span text-medium-500>{{ referralCode
                                                                                }}</span>
                                                                                <span><v-icon size="18"
                                                                                        class="ms-2 cursor-pointer hover:opacity-70"
                                                                                        @click="copyToClipboard(referralCode)">
                                                                                        {{ copied === referralCode ?
                                                                                            'mdi-check' :
                                                                                            'mdi-content-copy' }}
                                                                                    </v-icon></span>
                                                                            </div>

                                                                            <!-- Main Label -->
                                                                            <label
                                                                                class="text-sm font-medium text-gray-700 d-block text-center mb-2">
                                                                                Referral Link
                                                                            </label>

                                                                            <div class="d-flex justify-center py-2 mb-2"
                                                                                style="background-color: #ffffff;">
                                                                                <span text-medium-500>{{ referralLink
                                                                                }}</span>
                                                                                <span><v-icon size="18"
                                                                                        class="ms-2 cursor-pointer hover:opacity-70"
                                                                                        @click="copyToClipboard(referralLink)">
                                                                                        {{ copied === referralLink ?
                                                                                            'mdi-check' :
                                                                                            'mdi-content-copy' }}
                                                                                    </v-icon></span>
                                                                            </div>

                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-card>
                                                        </v-card>
                                                    </v-col>

                                                </v-row>

                                            </v-col>

                                        </v-row>
                                    </v-card>


                                </v-card>

                            </v-card>


                        </v-col>
                    </v-row>

                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useDashStore } from "@/store/dashboard"
import GlobalKyc from "@/components/GlobalKyc.vue"


//piniastore
// const trn = useTransactStore()
const dash = useDashStore()


const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)

const kinCollapsed = ref(true)
const termCollapsed = ref(true)

/* Mobile */
const toggleSidebar = () => {
    if (isMobile.value) drawerOpen.value = !drawerOpen.value
    else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768
    drawerOpen.value = !isMobile.value
}

const referralCode = computed(() => dash.user?.user?.ref_token || "N/A")
const totalReferred = computed(() => dash.user?.user?.referral_stats.total_referred || 0)
const totalEarnedBonus = computed(() => dash.user?.user?.referral_stats.total_bonus || 0)


const referralLink = computed(() => {
    return `${window.location.origin}/signup?ref=${referralCode.value}`
})

/* Lifecycle */
onMounted(async () => {
    checkMobile()
    window.addEventListener("resize", checkMobile)
    await dash.loadUser()
})

onUnmounted(() => {
    window.removeEventListener("resize", checkMobile)
})

//copy and paste
const copied = ref(null)
const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text)
        copied.value = text

        setTimeout(() => {
            copied.value = false
        }, 1500)
    } catch (err) {
        console.error(err)
    }
}
</script>

<style scoped>
.main {
    display: flex;
    min-height: 100vh;
}

.main-content {
    flex: 1;
    background: #f8fafc;
}

.content {
    padding-left: 10%;
    padding-right: 10%;
}

/* Card */
.table-card {
    padding: 20px;
    border-radius: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

.modern-input {
    width: 600px;
    height: 46px;
    margin-top: 6px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 15px;
    background: #fff;
    transition: all 0.2s ease;
}

/* Header */
.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

/* Table */
.modern-table {
    border: none;
}

/* Product */
.product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
}

.product-image {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
    margin-right: 2%;
}

.product-name {
    font-weight: 700;
}

.product-desc {
    font-size: 16px;
    color: #64748b;
}

/* Button */
.theme-button {
    height: 46px;
    width: 100%;
    background: #0f2638;
    color: #fff;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.25s ease;
}

.theme-button:hover {
    background: #292828;
}

.theme-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/**IOS toggle */
.ios-toggle {
    width: 44px;
    height: 24px;
    background-color: #ccc;
    border-radius: 999px;
    position: relative;
    transition: background-color 0.3s ease;
    border: none;
    cursor: pointer;
}

.ios-toggle.active {
    background-color: #22c55e;
    /* green */
}

.ios-toggle-knob {
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: transform 0.3s ease;
}

.ios-toggle.active .ios-toggle-knob {
    transform: translateX(20px);
}


/* Column title */
.column-title h5 {
    font-size: 1.1rem;
    font-weight: 400;
    margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
    border: none;
    height: 1px;
    background-color: #eae5e5;
    margin: 0;
    margin-bottom: 8px;
}

.product-card {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
}

/* Outer card wrapping the 4 inner cards */
.outer-card {
    border: 1px solid #e4dede;
    border-radius: 8px;
    background: #fff;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px;
}

/* Inner cards */
.inner-card {
    border: 1px solid #eae5e5;
    border-radius: 6px;
    padding: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.inner-mini-card {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fafafa;
}

.fill-height {
    height: 100%;
}

.spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}


/* Mobile */
@media (max-width: 900px) {
    .content {
        padding: 0;
    }

    .avatar-mobile {
        width: 32px;
        height: 32px;
    }

    .title-mobile {
        font-size: 0.9rem;
    }

    .icon-mobile {
        font-size: 16px;
    }

    .modern-input {
        width: 100%;

    }
}
</style>
